import type React from 'react';

export const PlaceholderIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
		<path
			d="M30.3998 7.99999V30.4H7.9998V7.99999H30.3998ZM30.3998 4.79999H7.9998C6.2398 6.23999 4.7998 6.23999 4.7998 7.99999V30.4C4.7998 32.16 6.2398 33.6 7.9998 33.6H30.3998C32.1598 33.6 33.5998 32.16 33.5998 30.4V7.99999C33.5998 6.23999 32.1598 4.79999 30.3998 4.79999ZM22.6238 18.976L17.8238 25.168L14.3998 21.024L9.5998 27.2H28.7998L22.6238 18.976Z"
			fill="#766F81"
		/>
	</svg>
);
